import React, { useState } from "react";
import InputField from "../components/InputField";
import Button from "../components/Button";
import { useSelector, useDispatch } from "react-redux";
import { getMappings, saveAsMappings } from "../store/workspaceSlice";

const initialObject = {
  // inColChr: "", // input column character
  // inColDT: "", // input column data type
  // grpBy: false, //groupby or not
  // grpByCol: [], // groupBy Column b , p
  // aggregateColumn: "", // j
  // grpByColMappings: {},
  // grpByOperation: "",
  // cmb: false, // has combinations
  // cmbData: [], // savedCombinations
  // cmbCol: "",
  // outputTargetCol: [], // character of output column where data should be stored
  // dateCol: "",
  // dateMask: "",
  // dateDays: "",
  // hasChrCodes: false,
  charCodes: [],
};

const AddCharactersPage = () => {
  const [characterCodes, setcharacterCodes] = useState([]);
  const dispatch = useDispatch();
  const [mapObject, setMappingsData] = useState(initialObject);
  const currentMaps = useSelector(getMappings);

  const handleAddNewRule = () => {
    dispatch(
      saveAsMappings({
        //_id: currentMaps.length + 1 saveMappings function will assign _Id,
        ruleName: "Character Codes",
        ...mapObject,
      })
    );
    setMappingsData(initialObject);
  };
  return (
    <div className="flex flex-col items-center space-y-4 py-2">
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 p-2 ">
        <InputField
          label="Cell value"
          type="text"
          placeholder={"Visa/Master"}
          value={characterCodes[0] || ""}
          onChange={(e) => {
            let temp = [...characterCodes]; // Create a copy of the array
            temp[0] = e.target.value; // Update the first index with the new value
            setcharacterCodes(temp);
          }}
        />
        <InputField
          label="Characte Code"
          type="text"
          placeholder={"VM"}
          value={characterCodes[1] || ""}
          onChange={(e) => {
            let temp = [...characterCodes]; // Create a copy of the array
            temp[1] = e.target.value; // Update the first index with the new value
            setcharacterCodes(temp);
          }}
        />
      </div>
      <Button
        disabled={characterCodes.length < 2} // Disable the button if there are less than 2 character codes
        btnText={"add character code"}
        handleOnClick={() => {
          setMappingsData((prevData) => ({
            ...prevData,
            charCodes: [...prevData.charCodes, [...characterCodes]],
          }));
          setcharacterCodes([]);
        }}
      />
      {/* show character codes  */}
      <div className="h-52  bg-gray-200 w-full p-2 rounded">
        <div className=" min-h-30 w-full p-2 rounded">
          <h1 className="font-bold">Character Codes</h1>
          {mapObject.charCodes.length > 0 ? (
            <ul className="list-disc list-inside max-h-40 min-h-30 overflow-y-auto p-2">
              {mapObject.charCodes.map((data, index) => (
                <li
                  key={index}
                  className="flex justify-between items-center bg-gray-100 P-2 my-1"
                >
                  <span>
                    "Character code for{" "}
                    <span className="font-bold">{data[0]}</span> is{" "}
                    <span className="font-bold">{data[1]}</span>
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-red-500">Add Character Codes</p>
          )}
        </div>
      </div>
      <div className="flex gap-4 w-full">
        <Button
          disabled={mapObject.charCodes.length === 0} // Disable the button if there are no character codes
          btnText={"Save"}
          handleOnClick={handleAddNewRule}
        />
        <Button
          btnType="cancel"
          disabled={mapObject.charCodes.length === 0} // Disable the button if there are no character codes
          btnText={"Reset"}
          handleOnClick={() => {
            setMappingsData(initialObject);
          }}
        />
      </div>
    </div>
  );
};

export default AddCharactersPage;
